import React from "react";

const ContactBox = ({ icon, title, desc, handleCLick }) => {
  return (
    <div className="contact-box" onClick={handleCLick}>
      <div>
        <div>{icon}</div>
        <p>{title}</p>
      </div>
      <p>{desc}</p>
    </div>
  );
};

export default ContactBox;
